export default class SheetEntry {
    public scale: number = 0;
    public lat: number = 0;
    public lng: number = 0;
    public name: string = '';
}
